// extracted by mini-css-extract-plugin
export default {"primaryText":"Growth_primaryText__xfac+","secondaryText":"Growth_secondaryText__jWxju","divBorder":"Growth_divBorder__KYfaG"};